import React, { useEffect, useState, useCallback, useRef } from 'react'
import axios from 'axios'

import { DropDown, Button, FlexWrap, Tag } from '../Components/'
import Timeline from '../timeline'
import shouldHighlight from '../Utils/shouldHighlight'
import transcriptProvider from '../transcriptProvider'
import captionsQueryBuilder from '../Utils/captionsQueryBuilder'
import { QueryParams } from '../Utils/queryParams'
import getEmotion from '../Utils/getEmotion'
import cx from '../Utils/cx'
import _ from 'lodash'
import AITab from './AITab'

import './Transcript.css'

let timeline
let currentCaption = null
let captionIndex = {}
let speakerColorsStyleSheet = document.createElement('style')
document.head.appendChild(speakerColorsStyleSheet)
let isProgrammaticScrollEvent = false
let enableAutoScrollTimer
let clearCurrentCaptionTimer
const clearCurrentCaptionDelayMs = 1500
// let nerWords = {
//     "name":["michelle"],
//     "country":["texas","us","usa"],
//     "commodity":["oil"]
// };

const generateRandomColors = (speakers) => {
    const num = speakers.length
    if (num === 0) return
    while (speakerColorsStyleSheet.sheet.rules.length !== 0) {
        speakerColorsStyleSheet.sheet.removeRule(0)
    }
    // yellow colours not included so won't be same as highlight
    const rgbVals = ['238,130,238', '0,0,128', '140,76,76', '270,150,0', '102,0,0', '0,128,128', '0,128,0', '245,125,75', '128,0,128', '170,0,0', '128,128,0',
        '140,112,76', '255,76,66', '255,0,255', '255,112,112', '79,70,0', '69,94,69', '255,69,112', '71,71,184', '220,175,90']

    // track duplicates to assign unique suffixes
    const speakerCount = {}
    speakers.forEach(speaker => {
        speakerCount[speaker] = (speakerCount[speaker] || 0) + 1
    })
    const speakerIndex = {}
    const speakerToClass = {}

    for (let i = 0; i < num; i++) {
        const speaker = speakers[i]
        const rgb = `rgb(${rgbVals[i % 20]})`

        // if duplicate, add suffix for unique CSS class
        let className = speaker.replace(/ /g, '_').replace(/[^a-zA-Z0-9_-]/g, '')
        if (speakerCount[speaker] > 1) {
            speakerIndex[speaker] = (speakerIndex[speaker] || 0) + 1
            className = `${className}_${speakerIndex[speaker]}`
        }

        speakerToClass[speaker] = className
        speakerColorsStyleSheet.sheet.insertRule(
            `.speaker_${className} {background: ${rgb}}`
        )
    }

    return speakerToClass
}

const seekToAndStyle = (
    seek,
    updateCurrentCaption,
    updateImageAndSoundCaptions,
    shouldAutoScroll
) => {
    const diff = timeline.seekToAndGetDiff(seek)
    let d, para
    for (d in diff) {
        para = document.querySelector(`[data-id="${d}"]`)
        const changedCaption = captionIndex[d]
        if (!changedCaption) continue
        if (diff[d] === -1) {
            if (para) para.className = ''
            if (changedCaption.isImageOrSoundCaption) {
                const id = d
                updateImageAndSoundCaptions((current) => {
                    return [...current].filter((c) => c.id !== id)
                })
            }
        } else if (diff[d] === 1) {
            const cc = changedCaption
            if (changedCaption.isImageOrSoundCaption) {
                updateImageAndSoundCaptions((current) => {
                    return [...current, cc]
                })
            } else {
                if (para) para.className = 'bold'
            }
        }
    }

    const speechCaptions = Object.values(captionIndex)
        .filter((c) => !c.isImageOrSoundCaption)
        .sort((a, b) => a.startTime - b.startTime || a.endTime - b.endTime)

    const activeSpeechCaptions = speechCaptions.filter(
        (c) => c.startTime <= seek && seek < c.endTime
    )

    const resolvedCurrentCaption =
        activeSpeechCaptions.length > 0
            ? activeSpeechCaptions[activeSpeechCaptions.length - 1]
            : null

    if (!resolvedCurrentCaption) {
        if (!currentCaption || clearCurrentCaptionTimer) return
        clearCurrentCaptionTimer = setTimeout(() => {
            currentCaption = null
            updateCurrentCaption(null)
            clearCurrentCaptionTimer = null
        }, clearCurrentCaptionDelayMs)
        return
    }

    if (clearCurrentCaptionTimer) {
        clearTimeout(clearCurrentCaptionTimer)
        clearCurrentCaptionTimer = null
    }

    const currentCaptionIndex = speechCaptions.findIndex(
        (c) => c.id === resolvedCurrentCaption.id
    )
    const previousCaption = speechCaptions[currentCaptionIndex - 1]
    const nextCaption = speechCaptions[currentCaptionIndex + 1]

    if (!currentCaption || currentCaption.id !== resolvedCurrentCaption.id) {
        currentCaption = resolvedCurrentCaption
        updateCurrentCaption({ previousCaption, currentCaption, nextCaption })
        if (shouldAutoScroll) {
            const currentPara = document.querySelector(
                `[data-id="${resolvedCurrentCaption.id}"]`
            )
            if (currentPara) {
                isProgrammaticScrollEvent = true
                currentPara.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }
    }
}

const Word = React.memo((props) => {
    const { ssidx, idx, word, queryWords, highlightSentence } = props
    // console.log(ssidx, idx);

    let modWord = word;
    // let mark
    let className

    // for (var key in nerWords){
    //     if (nerWords[key].includes(word)){
    //         mark = key;
    //         break;
    //     }
    // }

    if (shouldHighlight(word, queryWords)) {
        highlightSentence(word)
        className = "highlight"
    }
    /*
    if (idx === 1 && ssidx === 0) {
        modWord = _.capitalize(word);
        // console.log(modWord);
    } */
    // return mark ? (
    //     <label data-entity={mark} style={{ marginRight: 5 }}>
    //         {modWord}
    //     </label>
    return className ? (
        <label className={className} style={{ marginRight: 5 }}>
            {modWord}
        </label>
    ) : (
        `${modWord} `
    )
})

const SpeechSubSegment = (props) => {
    const {
        idx,
        speechSubSegment,
        setHighlight,
        queryWordsDict,
        isImageCaption,
        isSoundCaption,
        query,
    } = props
    const { startTime, endTime, id, words } = speechSubSegment
    useEffect(
        (_) => {
            timeline.add(startTime, endTime, id)
            captionIndex[id] = {
                id,
                startTime,
                text: words.join(' '),
                endTime,
                isImageOrSoundCaption: isImageCaption || isSoundCaption,
            }
        },
        [endTime, id, startTime, words, isImageCaption, isSoundCaption]
    )
    useEffect(
        (_) => {
            setHighlighted(false)
        },
        [query]
    )
    const [highlighted, setHighlighted] = useState(false)
    const highlightSentence = useCallback(
        (word) => {
            if (highlighted) return
            setHighlighted(true)
            setHighlight(startTime, endTime - startTime, word)
        },
        [highlighted, setHighlight, startTime, endTime]
    )
    let _key = 0
    const { fields = {}, text } = queryWordsDict
    const { uniqueWordsImage, uniqueWordsSound, uniqueWordsSpeech } = fields
    const queryWords = []
    if (uniqueWordsImage && isImageCaption)
        queryWords.push(...uniqueWordsImage.split(' '))
    if (uniqueWordsSound && isSoundCaption)
        queryWords.push(...uniqueWordsSound.split(' '))
    if (uniqueWordsSpeech) queryWords.push(...uniqueWordsSpeech.split(' '))
    if (text) queryWords.push(...text.split(' '))
    return (
        <span
            data-id={id}
            data-role="speechSubSegment"
            style={{ marginRight: '0' }}
        >
            {(isImageCaption || isSoundCaption) && '[ '}
            {words.map((w) => (
                <Word
                    ssidx={idx}
                    key={_key++}
                    idx={_key}
                    word={w}
                    queryWords={queryWords}
                    highlightSentence={highlightSentence}
                />
            ))}
            {(isImageCaption || isSoundCaption) && ']'}
        </span>
    )
}

const DataSegment = (props) => {
    const {
        dataSegment,
        jumpTo,
        setHighlight,
        query,
        queryWordsDict,
        onSpeakerChange,
        speakerToClass,
        ...otherProps
    } = props
    const {
        startTime,
        speakerId = 'S',
        emotion = null,
        speechSubSegments,
        endTime,
        id,
    } = dataSegment
    const isImageCaption = speakerId === 'imageCaption'
    const isSoundCaption = speakerId === 'soundCaption'
    const dataType =
        isImageCaption || isSoundCaption ? speakerId : 'speechSegment'
    const [highlighted, setHighlighted] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [editedSpeakerId, setEditedSpeakerId] = useState(speakerId)
    const highlightSegment = useCallback(
        (word) => {
            if (highlighted) return
            setHighlighted(true)
            setHighlight(startTime, endTime - startTime, word)
        },
        [highlighted, setHighlight, startTime, endTime]
    )
    useEffect(
        (_) => {
            setHighlighted(false)
        },
        [query]
    )
    const speakerQuery = new QueryParams(query).params.SPEAKER
    const doesQueryHaveSpeaker =
        speakerQuery && shouldHighlight(speakerId, speakerQuery.split(' '))
    if (doesQueryHaveSpeaker) {
        highlightSegment(speakerId)
    }
    const parsedEmotion = getEmotion(emotion)
    const doesQueryHaveEmotion =
        emotion &&
        queryWordsDict.fields &&
        queryWordsDict.fields.emotion === emotion.toLowerCase()
    if (doesQueryHaveEmotion && parsedEmotion) {
        highlightSegment(parsedEmotion.name)
    }
    let _idx = 0

    const handleSpeakerClick = (e) => {
        e.stopPropagation()
        if (!isImageCaption && !isSoundCaption) {
            setIsEditing(true)
        }
    }

    const handleSpeakerBlur = () => {
        setIsEditing(false)
        if (editedSpeakerId !== speakerId && onSpeakerChange) {
            onSpeakerChange(speakerId, editedSpeakerId)
        }
    }

    const handleSpeakerKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            setIsEditing(false)
            if (editedSpeakerId !== speakerId && onSpeakerChange) {
                onSpeakerChange(speakerId, editedSpeakerId)
            }
        } else if (e.key === 'Escape') {
            setIsEditing(false)
            setEditedSpeakerId(speakerId)
        }
    }

    return (
        <div
            data-id={id}
            data-endtime={endTime}
            data-role={dataType}
            onClick={(_) => {
                jumpTo(startTime)
            }}
            className={parsedEmotion ? 'hasEmotion' : ''}
        >
            <p style={{ marginBottom: '10px' }}>
                <span className="segmentMeta">
                    {isEditing ? (
                        <input
                            type="text"
                            value={editedSpeakerId}
                            onChange={(e) => setEditedSpeakerId(e.target.value)}
                            onBlur={handleSpeakerBlur}
                            onKeyDown={handleSpeakerKeyDown}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                            style={{
                                fontSize: 'inherit',
                                padding: '2px 4px',
                                borderRadius: '3px',
                                border: '1px solid #ccc',
                            }}
                        />
                    ) : (
                        <label
                            className={`speaker speaker_${speakerToClass[speakerId] || speakerId.replace(
                                / /g,
                                '_'
                            )} ${highlighted && 'highlight'} ${!isImageCaption && !isSoundCaption ? 'editable' : ''
                                }`}
                            onClick={handleSpeakerClick}
                            style={{
                                cursor: !isImageCaption && !isSoundCaption ? 'pointer' : 'default',
                            }}
                        >
                            {isImageCaption || isSoundCaption ? '**' : speakerId}
                        </label>
                    )}
                    {parsedEmotion && (
                        <span
                            className="emotionChip"
                            style={{ '--emotion-color': parsedEmotion.color }}
                        >
                            <span className="emoji">{parsedEmotion.emoji}</span>
                            <span className="emotionName">
                                {parsedEmotion.name}
                            </span>
                        </span>
                    )}
                </span>
                {speechSubSegments.map((sss) => (
                    <SpeechSubSegment
                        idx={_idx++}
                        key={sss.id}
                        speechSubSegment={sss}
                        isImageCaption={isImageCaption}
                        isSoundCaption={isSoundCaption}
                        setHighlight={setHighlight}
                        query={query}
                        queryWordsDict={queryWordsDict}
                        {...otherProps}
                    />
                ))}
            </p>
        </div>
    )
}

const TranscriptBody = React.memo((props) => {
    const { query = '', dataSegments, className, ...otherProps } = props
    const queryWordsDict = captionsQueryBuilder(query)
    try {
        return (
            <div
                id="transcript"
                style={{ margin: '15px 0' }}
                //mark={mark}
                className={className}
            >
                {dataSegments.map((dataSegment) => (
                    <DataSegment
                        key={dataSegment.id}
                        query={query}
                        queryWordsDict={queryWordsDict}
                        dataSegment={dataSegment}
                        {...otherProps}
                    />
                ))}
            </div>
        )
    } catch (e) {
        console.error(e)
        return <p>Error Parsing Transcript: Invalid JSON Structure</p>
    }
})

const TranscriptRenderer = (props) => {
    const {
        seek,
        updateCurrentCaption,
        updateImageAndSoundCaptions,
        recordingId,
        highlights,
        query = '',
        setSpeakers,
        transcriptId,
        activeTab,
        showOptions,
        setShowOptions,
        showOptionsButtonRef,
        tags = [],
        recordingSpeakers = [],
        performSearch,
        selectedTranscript,
        setSelectedTranscriptId,
        ...otherProps
    } = props

    const [topWords, setTopWords] = useState([])

    // panel position calculated from the "Show options" button from index.js
    const PANEL_WIDTH = 300
    const showOptionsButtonRect =
        showOptions && showOptionsButtonRef?.current
            ? showOptionsButtonRef.current.getBoundingClientRect()
            : null
    const optionsPanelStyle = showOptionsButtonRect
        ? {
            top: showOptionsButtonRect.bottom + 8,
            left: Math.max(
                8,
                Math.min(
                    showOptionsButtonRect.left,
                    window.innerWidth - PANEL_WIDTH - 8
                )
            ),
            maxHeight: window.innerHeight - showOptionsButtonRect.bottom - 24,
        }
        : undefined

    const [dataSegments, setDataSegments] = useState(null)
    const [error, setError] = useState(null)
    const [speakerToClass, setSpeakerToClass] = useState({})
    const optionsPanelRef = useRef(null)

    useEffect(() => {
        // Close the options panel if the user clicks outside of it
        if (!showOptions) return
        const handleClickOutside = (e) => {
            const clickedButton =
                showOptionsButtonRef?.current && showOptionsButtonRef.current.contains(e.target)
            if (clickedButton) return
            if (optionsPanelRef.current && !optionsPanelRef.current.contains(e.target)) {
                setShowOptions(false)
            }
        }
        // Add the event listener when the panel is shown, and remove it when the panel is hidden
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [showOptions, setShowOptions, showOptionsButtonRef])

    // returns the set of currently-known speaker names (excluding entity being renamed)
    const getOtherSpeakerNames = (excludeSpeakerId) => {
        const names = new Set()
        if (dataSegments) {
            dataSegments.forEach((seg) => {
                const sid = seg.speakerId
                if (!sid || sid === 'imageCaption' || sid === 'soundCaption') return
                if (sid === excludeSpeakerId) return
                names.add(sid)
            })
        }
        return names
    }

    const handleSpeakerChange = async (originalSpeakerId, newSpeakerId) => {
        try {
            // prevent two different speakers from ending up with same names
            // auto-suffix on collision
            const otherNames = getOtherSpeakerNames(originalSpeakerId)
            let finalSpeakerId = newSpeakerId
            if (otherNames.has(finalSpeakerId)) {
                let n = 2
                while (otherNames.has(`${newSpeakerId}_${n}`)) n++
                finalSpeakerId = `${newSpeakerId}_${n}`
            }

            const studioUrl = process.env.REACT_APP_STUDIO_URL
            const token = localStorage.getItem('token')

            const transcriptPath = transcript?.tempResourceUrl || transcript?.azureResourceUrl
            if (!transcriptPath) {
                console.error('No transcript path found')
                return
            }

            const fileName = transcriptPath.substring(transcriptPath.lastIndexOf('/') + 1)

            // fetch current transcript XML (check draft first)
            let draftPath
            if (transcript?.draftResourceUrl) {
                // extract relative path
                const relativeDraftPath = transcript.draftResourceUrl.includes('transcripts/')
                    ? transcript.draftResourceUrl.substring(transcript.draftResourceUrl.indexOf('transcripts/'))
                    : `transcripts/draft/${fileName}`
                draftPath = `${studioUrl}/static/${relativeDraftPath}`
            } else {
                draftPath = `${studioUrl}/static/transcripts/${fileName}`
            }
            const response = await axios.get(draftPath)
            let xmlContent = response.data

            // replace speaker IDs (spkrid in XML)
            if (fileName.endsWith('.xml')) {
                const regex = new RegExp(`spkrid="${originalSpeakerId}"`, 'g')
                xmlContent = xmlContent.replace(regex, `spkrid="${finalSpeakerId}"`)
            }

            await axios.put(
                `${studioUrl}/upload/transcript`,
                { fileName, data: xmlContent, isDraft: true },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            )

            // update transcript object to point to draft location
            const updatedTranscript = {
                ...transcript,
                draftResourceUrl: `transcripts/draft/${fileName}`
            }
            setTranscript(updatedTranscript)

            // reload the transcript to reflect changes
            setDataSegments(null)
            setError(null)

            timeline = new Timeline()
            captionIndex = {}

        } catch (error) {
            console.error('Failed to update speaker:', error)
        }
    }

    const transcripts = props.transcripts
    const imageCaptions = props.imageCaptions
    const soundCaptions = props.soundCaptions
    let defaultTranscript = _.find(
        transcripts,
        (tx) => tx._id === props.defaultTranscript
    )
    if (!defaultTranscript && transcripts.length) {
        defaultTranscript = transcripts[0]
    }
    if (transcriptId) {
        defaultTranscript = transcripts.find((f) => f._id === transcriptId)
    }

    const defaultImageCaption = _.find(
        imageCaptions,
        (ic) => ic._id === props.defaultImageCaption
    )
    const defaultSoundCaption = _.find(
        soundCaptions,
        (sc) => sc._id === props.defaultSoundCaption
    )

    const [transcript, setTranscript] = useState(
        selectedTranscript || defaultTranscript
    )

    // follow the selection when it is changed in the editor
    useEffect(() => {
        if (selectedTranscript) setTranscript(selectedTranscript)
    }, [selectedTranscript])

    const [imageCaption, setImageCaption] = useState(defaultImageCaption)
    const [soundCaption, setSoundCaption] = useState(defaultSoundCaption)
    const [showTx, setShowTx] = useState(true)
    const [showImgCap, setShowImgCap] = useState(true)
    const [showSndCap, setShowSndCap] = useState(true)
    const [shouldAutoScroll, setShouldAutoScroll] = useState(true)

    useEffect(
        (_) => {
            setDataSegments(null)
            setError(null)

            timeline = new Timeline()
            captionIndex = {}

            transcriptProvider(
                transcript,
                imageCaption,
                soundCaption,
                recordingId
            )
                .then(
                    ([
                        speakers,
                        _speechSegments,
                        _soundSegments = [],
                        _imageSegments = [],
                        topWords = [],
                    ]) => {
                        const speakerToClass = generateRandomColors(speakers)
                        setSpeakerToClass(speakerToClass)
                        setSpeakers(speakers)
                        setDataSegments(
                            [
                                ..._speechSegments,
                                ..._soundSegments,
                                ..._imageSegments,
                            ].sort((a, b) => a.startTime - b.startTime)
                        )
                        setTopWords(topWords)
                    }
                )
                .catch((err) => {
                    console.error('Failed to load transcript', transcript, err)
                    setError(err)
                })
        },
        [
            transcript,
            imageCaption,
            soundCaption,
            recordingId,
            setSpeakers,
            setTopWords,
        ]
    )

    useEffect(
        (_) => {
            seekToAndStyle(
                seek,
                updateCurrentCaption,
                updateImageAndSoundCaptions,
                shouldAutoScroll
            )
        },
        [
            seek,
            updateCurrentCaption,
            updateImageAndSoundCaptions,
            shouldAutoScroll,
        ]
    )

    const enableAutoScroll = () => {
        setShouldAutoScroll(true)
        if (enableAutoScrollTimer) clearTimeout(enableAutoScrollTimer)
    }
    const keepManuallyScrolling = () => {
        setShouldAutoScroll(false)
        if (enableAutoScrollTimer) clearTimeout(enableAutoScrollTimer)
        enableAutoScrollTimer = setTimeout(
            () => setShouldAutoScroll(true),
            1000
        )
    }

    if (dataSegments)
        return (
            <>
                {showOptions && (
                    <div
                        className="transcriptOptionsPanel"
                        ref={optionsPanelRef}
                        style={optionsPanelStyle}
                    >
                        <div className="ops selectTranscript optionsPanelTranscript">
                            <label>Transcript:</label>
                            <select
                                className="optionsPanelSelect"
                                value={transcript?._id || ''}
                                onChange={(e) => {
                                    const match = transcripts.find(
                                        (t) => t._id === e.target.value
                                    )
                                    if (match) {
                                        setTranscript(match)
                                        if (setSelectedTranscriptId)
                                            setSelectedTranscriptId(match._id)
                                    }
                                }}
                            >
                                {transcripts.map((t) => (
                                    <option key={t._id} value={t._id}>
                                        {t.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {imageCaptions.length > 0 && (
                            <div className="ops selectTranscript optionsPanelImageCaption">
                                <label>Image Caption:</label>
                                <select
                                    className="optionsPanelSelect"
                                    value={imageCaption?._id || ''}
                                    onChange={(e) => {
                                        const match = imageCaptions.find(
                                            (c) => c._id === e.target.value
                                        )
                                        if (match) setImageCaption(match)
                                    }}
                                >
                                    {imageCaptions.map((c) => (
                                        <option key={c._id} value={c._id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {soundCaptions.length > 0 && (
                            <div className="ops selectTranscript optionsPanelSoundCaption">
                                <label>Sound Caption:</label>
                                <select
                                    className="optionsPanelSelect"
                                    value={soundCaption?._id || ''}
                                    onChange={(e) => {
                                        const match = soundCaptions.find(
                                            (c) => c._id === e.target.value
                                        )
                                        if (match) setSoundCaption(match)
                                    }}
                                >
                                    {soundCaptions.map((c) => (
                                        <option key={c._id} value={c._id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className="ops transcriptFilters">
                            <label className="filtersHeading">Filters:</label>
                            <label className="filterOption">
                                <input
                                    type="checkbox"
                                    onChange={(_) => setShowTx(!showTx)}
                                    checked={showTx}
                                />
                                Show Transcript
                            </label>
                            <label className="filterOption">
                                <input
                                    type="checkbox"
                                    onChange={(_) => setShowImgCap(!showImgCap)}
                                    checked={showImgCap}
                                />
                                Show Image Captions
                            </label>
                            <label className="filterOption">
                                <input
                                    type="checkbox"
                                    onChange={(_) => setShowSndCap(!showSndCap)}
                                    checked={showSndCap}
                                />
                                Show Sound Captions
                            </label>
                        </div>
                        {tags.length > 0 && (
                            <div className="ops optionsPanelMetaGroup">
                                <label className="filtersHeading">Tags:</label>
                                <FlexWrap className="recordingTagsContainer">
                                    {tags.slice(0, 15).map((tag) => (
                                        <Tag
                                            queryWords={query ? query.split(' ') : null}
                                            onClick={() => performSearch(tag)}
                                            key={tag}
                                            name={tag}
                                        />
                                    ))}
                                </FlexWrap>
                            </div>
                        )}
                        {recordingSpeakers.length > 0 && (
                            <div className="ops optionsPanelMetaGroup">
                                <label className="filtersHeading">Speakers:</label>
                                <FlexWrap className="recordingTagsContainer">
                                    {recordingSpeakers.map((s) => (
                                        <Tag
                                            queryWords={query ? query.split(' ') : null}
                                            onClick={() => performSearch(`speaker:${s}`)}
                                            key={s}
                                            name={s}
                                        />
                                    ))}
                                </FlexWrap>
                            </div>
                        )}
                        {topWords.length > 0 && (
                            <div className="ops optionsPanelMetaGroup">
                                <label className="filtersHeading">Top Words:</label>
                                <FlexWrap className="recordingTagsContainer">
                                    {topWords
                                        .filter((t) => t?.[0]?.trim())
                                        .map((t) => {
                                            const topWord = t[0]
                                            return (
                                                <Tag
                                                    onClick={() => performSearch(topWord)}
                                                    key={topWord}
                                                    name={topWord}
                                                />
                                            )
                                        })}
                                </FlexWrap>
                            </div>
                        )}
                    </div>
                )}
                {activeTab === 'transcript' ? (
                    <div
                        id="TranscriptRenderer"
                        onScroll={(_) => {
                            if (!isProgrammaticScrollEvent) {
                                keepManuallyScrolling()
                                isProgrammaticScrollEvent = false
                            }
                        }}
                        onWheel={keepManuallyScrolling}
                    >
                        <Button
                            small
                            className={cx({
                                autoScroll: true,
                                visible: !shouldAutoScroll,
                            })}
                            onClick={enableAutoScroll}
                        >
                            Enable auto scroll
                        </Button>
                        <TranscriptBody
                            dataSegments={dataSegments}
                            query={query}
                            className={cx({
                                noTx: !showTx,
                                noImgCap: !showImgCap,
                                noSndCap: !showSndCap,
                            })}
                            onSpeakerChange={handleSpeakerChange}
                            speakerToClass={speakerToClass}
                            {...otherProps}
                        />
                    </div>
                ) : (
                    <AITab
                        transcriptData={dataSegments}
                        transcriptXMLPath={transcript?.azureResourceUrl || ''}
                        fileName={transcript?.name || ''}
                        mediaId={recordingId}
                        onTimestampClick={(seconds) => props.jumpTo(seconds * 1000)}
                    />
                )}
            </>
        )

    if (error)
        return (
            <>
                <div className="ops selectTranscript">
                    <label>Transcript:</label>
                    <DropDown
                        list={transcripts}
                        _key="name"
                        selected={transcript}
                        setSelected={(t) => {
                            setTranscript(t)
                            if (setSelectedTranscriptId)
                                setSelectedTranscriptId(t._id)
                        }}
                        white
                    />
                </div>
                <p>
                    <strong>Error Occured:</strong>
                </p>
                {typeof error === 'string' ? (
                    <p>{error}</p>
                ) : (
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                )}
            </>
        )

    return <p>Loading...</p>
}

export default TranscriptRenderer;